import type {
  ChangeComputerProductionUpgradePolicyReply,
  ChangeComputerProductionUpgradePolicyRequest,
  ComputerProductionUpgradeApprovalReply,
  GetComputerProductionUpgradePolicyReply,
} from '@/types';
import api from './api';

const COMPUTER_PRODUCTION_UPGRADE_POLICY_PATH =
  '/api/v1/app-config/computer-production-upgrade-policy';

export const computerProductionUpgradePolicyApi = {
  get: async (
    approvalPageToken = '',
  ): Promise<GetComputerProductionUpgradePolicyReply> =>
    api.get(COMPUTER_PRODUCTION_UPGRADE_POLICY_PATH, {
      params: {
        approvalPageSize: 50,
        ...(approvalPageToken ? { approvalPageToken } : {}),
      },
    }),

  change: async (
    request: ChangeComputerProductionUpgradePolicyRequest,
  ): Promise<ChangeComputerProductionUpgradePolicyReply> =>
    api.post(`${COMPUTER_PRODUCTION_UPGRADE_POLICY_PATH}/change`, request),

  approve: async (
    approvalId: string,
  ): Promise<ComputerProductionUpgradeApprovalReply> =>
    api.post(`${COMPUTER_PRODUCTION_UPGRADE_POLICY_PATH}/approvals/approve`, {
      approvalId,
    }),

  reject: async (
    approvalId: string,
    reason: string,
  ): Promise<ComputerProductionUpgradeApprovalReply> =>
    api.post(`${COMPUTER_PRODUCTION_UPGRADE_POLICY_PATH}/approvals/reject`, {
      approvalId,
      reason,
    }),

  withdraw: async (
    approvalId: string,
  ): Promise<ComputerProductionUpgradeApprovalReply> =>
    api.post(`${COMPUTER_PRODUCTION_UPGRADE_POLICY_PATH}/approvals/withdraw`, {
      approvalId,
    }),
};
